const PAGE_FRAME_HEIGHT = "calc(100vh - 13px)"; // 12px padding, 1px border

export { PAGE_FRAME_HEIGHT };
